<template>
  <div class="market-area">
    <div class="banner" :style="`background-image: url(${bannerUrl})`">
      <div class="banner-content">
        <div class="banner-content-info">
          {{ $t('marketArea.bannerTitle') }}
          <span></span>
        </div>
      </div>
    </div>

    <div v-if="$route.path === '/marketArea'" class="content">
      <div class="content-header">
        <h2>{{ $t('marketArea.title') }}</h2>
        <span></span>
      </div>
      <div class="content-list">
        <div 
          class="content-list-item" 
          v-for="(item, index) in marketList" 
          :key="index"
          :style="`background-image: url(${item.cover})`"
          :class="{'more': marketList.length - 1 === index}"
          @click="routerClick(item.path)"
        >
          <div class="item-title">{{ item.title }}</div>
          <div class="item-content single-line">{{ item.content }}</div>
          <div v-if="marketList.length - 1 > index" class="item-more">{{ $t('marketArea.more') }}<span> ></span></div>
        </div>
      </div>
    </div>
    <router-view v-else ></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bannerUrl: require('@/assets/images/marketArea/banner.png')
    }
  },
  computed: {
    marketList() {
      return [
        { 
          title: this.$t('marketArea.list.chemical.title'), 
          path: '/marketArea/chemicalEngineering', 
          cover: require('@/assets/images/marketArea/list1.png'), 
          content: this.$t('marketArea.list.chemical.content')
        },
        { 
          title: this.$t('marketArea.list.spaceflight.title'), 
          path: '/marketArea/spaceflight', 
          cover: require('@/assets/images/marketArea/list2.png'), 
          content: this.$t('marketArea.list.spaceflight.content')
        },
        { 
          title: this.$t('marketArea.list.electron.title'), 
          path: '/marketArea/electron', 
          cover: require('@/assets/images/marketArea/list3.png'), 
          content: this.$t('marketArea.list.electron.content')
        },
        { 
          title: this.$t('marketArea.list.AI.title'), 
          path: '/marketArea/AI', 
          cover: require('@/assets/images/marketArea/list4.png'), 
          content: this.$t('marketArea.list.AI.content')
        },
        { 
          title: this.$t('marketArea.list.transportation.title'), 
          path: '/marketArea/transportation', 
          cover: require('@/assets/images/marketArea/list5.png'), 
          content: this.$t('marketArea.list.transportation.content')
        },
        { 
          title: this.$t('marketArea.list.newEnergy.title'), 
          path: '/marketArea/newEnergy', 
          cover: require('@/assets/images/marketArea/list6.png'), 
          content: this.$t('marketArea.list.newEnergy.content')
        },
        { 
          title: this.$t('marketArea.list.architecture.title'), 
          path: '/marketArea/architecture', 
          cover: require('@/assets/images/marketArea/list7.png'), 
          content: this.$t('marketArea.list.architecture.content')
        },
        { 
          title: this.$t('marketArea.list.homeAppliances.title'), 
          path: '/marketArea/homeAppliances', 
          cover: require('@/assets/images/marketArea/list8.png'), 
          content: this.$t('marketArea.list.homeAppliances.content')
        },
        { 
          title: this.$t('marketArea.exploreMore'), 
          path: '', 
          cover: require('@/assets/images/marketArea/list9.png'), 
          content: '' 
        },
      ]
    }
  },
  methods: {
    routerClick (path) {
      if (!path) return 
      document.querySelector('body').scroll(0, 650)
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="scss">
.market-area  {
  position: relative;
  .banner {
    height: 405px;
    display: block;
    margin: 0 auto;
    background-size: 1920px 570px;
    padding-top: 165px;
    .banner-content {
      width: 1200px;
      margin: 0 auto;
      .banner-content-info {
        width: 354px;
        height: 82px;
        border: 1px solid #fff;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(20px);
        font-weight: 600;
        font-size: 44px;
        color: #fff;
        padding: 70px 60px 80px;
        span {
          width: 80px;
          height: 4px;
          background: rgba(255, 255, 255, 1);
          display: block;
          margin-top: 16px;
        }
      }
    }
  }
  
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 100px;
    padding-bottom: 85px;
    .content-list {
      margin-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .content-list-item {
        width: 320px;
        height: 320px;
        background-size: 100% 100%;
        padding: 30px;
        margin: 12px;
        transition: all .5s;
        background-position: center center;
        cursor: pointer;
        &:nth-child(3n) {
          margin-right: 0px;
        }
        &:hover {
          background-size: 110% 110%;
        }
        &.more {
          text-align: center;
          .item-title {
            padding: 0;
            line-height: 320px;
          }
        }
        .item-title {
          padding-top: 188px;
          font-weight: 700;
          font-size: 28px;
          line-height: 36px;
          color: #fff;
        }
        .item-content {
          padding-top: 16px;
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          color: #fff;
        }
        .item-more {
          padding-top: 40px;
          font-weight: 600;
          font-size: 16px;
          line-height: 20px;
          color: #fff;
          cursor: pointer;
          span { 
            padding-left: 10px;
          }
        }
      }
    }
  }
  .content-header {
    padding-left: 15px;
    h2 {
      font-weight: 600;
      font-size: 36px;
      line-height: 50px;
    }
    span {
      margin-top: 16px;
      width: 80px;
      height: 4px;
      display: block;
      background-color: rgb(28, 100, 215);
    }
  } 
}
</style>